module.exports = __webpack_public_path__ + "img/Ardunic Elements-181.2daae4a1.svg";